import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import SortDropdown from "src/app/components/SortDropdown/SortDropdown";
import { TooltipedEllipsis } from "src/app/components/TooltipedEllipsis/TooltipedEllipsis";
import { ReactComponent as SortIcon } from "src/images/up-down.svg";

export default function SortResultsDropdown({
  options,
  sortBy,
  handleClick,
  disabled,
}) {
  const activeSortingColumnName = options.find(
    (option) => option.uuid === sortBy,
  )?.name;
  return (
    <SortDropdown options={options} sortBy={sortBy} handleClick={handleClick}>
      <Button
        variant="white"
        size="medium"
        textWithIcon
        dataQa="sort-button"
        disabled={disabled}
      >
        <SortIcon />
        <IDHFormattedMessage id="ws_sort" defaultMessage="Sort" />
        {activeSortingColumnName ? (
          <>
            :{" "}
            <TooltipedEllipsis
              className="sort-fields-dropdown__active-filter-ellipsis"
              maxWidth={100}
              content={activeSortingColumnName}
            />
          </>
        ) : null}
      </Button>
    </SortDropdown>
  );
}
